<template>
  <div>
    <CCard></CCard>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <div class="flex">
              <h1>Handlowcy</h1>

              <CButton
                color="warning"
                class="btnAddToTree"
                @click="mthAddNewRepresentative()"
              >Dodaj nowego handlowca</CButton>
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                <CRow>
                  <CCol sm="12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">Imię handlowca</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="B2BproductRow"
                          v-for="(item,index) in handlowcy"
                          v-bind:key="item.id"
                        >
                          <td @click="mthToggleEdit(index)" scope="col">
                            <template
                              v-if="index!=editindex"
                            >{{mthEmptyToText(item.imie,"(kliknij tutaj aby wpisać imię nowego handlowca)")}}</template>
                            <template v-else>
                              <input
                                v-focus
                                type="text"
                                v-model="item.imie"
                                @change="mthSaveModifiedField(index,item.id,'imie')"
                              />
                            </template>
                          </td>
                          <td align="right">
                            <span @click="mthDeleteSalesman(item.id)">
                              <CIcon name="cil-trash" alt="usuń handlowca" />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import { freeSet } from "@coreui/icons";

export default {
  name: "b2bsalesrepresentatives",
  freeSet,
  created() {
    this.mthFillData();
  },
  directives: {
    focus: {
      // directive definition
      inserted: function (el) {
        el.focus();
      },
    },
  },
  data() {
    return {
      editindex: -1,
      newfirstname: "",
      handlowcy: [],
    };
  },
  methods: {
    mthDeleteSalesman(id) {
      if (confirm("Czy na pewno usunąć?")) {
        var apiurl =
          process.env.VUE_APP_API_URL + "/b2bstardelflag?a=handlowcy&b=" + id;

        var that = this;

        this.$axios({
          method: "get",
          url: apiurl,
        })
          .then(function (response) {
            that.mthFillData();
          })
          .catch(function (error) {
            //console.log(error);
            that.loginsuccess = false;
            that.loginresultmsg = "Brak połączenia z API (" + error + ").";
          });
      }
    },
    mthSaveModifiedField(index, primary_key_value, fieldname) {
      var that = this;
      var apiurl =
        process.env.VUE_APP_API_URL +
        "/b2bsetattrvalfromtbl?tbln=handlowcy" +
        "&key1n=id" +
        "&key1v=" +
        primary_key_value +
        "&key2n=" +
        "&key2v=" +
        "&fieldn=" +
        fieldname +
        "&data=" +
        encodeURIComponent(this.handlowcy[index].imie) +
        "&index=" +
        index +
        "&datatype=txt";
      this.$axios({
        method: "get",
        url: apiurl,
      })
        .then(function (response) {
          that.editindex = -1;
          that.mthFillFormData();
        })
        .catch(function (error) {
          that.loginsuccess = false;
          that.loginresultmsg = "Brak połączenia z API (" + error + ").";
        });
    },
    mthEmptyToText(t, repl) {
      if (t == "" || t == null) return repl;
      return t;
    },
    mthToggleEdit(index) {
      if (this.editindex != -1 && this.editindex == index) this.editindex = -1;
      else this.editindex = index;
    },
    mthAddNewRepresentative() {
      var apiurl =
        process.env.VUE_APP_API_URL + "/b2binsertdefault?a=handlowcy";

      var that = this;

      this.$axios({
        method: "get",
        url: apiurl,
      })
        .then(function (response) {
          console.log(response.data);
          that.mthFillData();
        })
        .catch(function (error) {
          console.log(error);
          that.loginsuccess = false;
          that.loginresultmsg = "Brak połączenia z API (" + error + ").";
        });
    },
    mthFillData() {
      var apiurl = process.env.VUE_APP_API_URL + "/b2bstar?a=handlowcy";

      var that = this;

      this.$axios({
        method: "get",
        url: apiurl,
      })
        .then(function (response) {
          console.log("api response:");
          console.log(response.data);
          that.handlowcy = response.data;
        })
        .catch(function (error) {
          console.log(error);
          that.loginsuccess = false;
          that.loginresultmsg = "Brak połączenia z API (" + error + ").";
        });
    },
  },
};
</script>

<style scoped>
input[type="text"] {
  width: 100%;
  background-color: yellow;
  height: 100%;
}
.flex {
  display: flex;
  justify-content: space-between;
}
</style>